import { render, staticRenderFns } from "./PengajuanDasar.vue?vue&type=template&id=1f498d52&"
import script from "./PengajuanDasar.vue?vue&type=script&lang=js&"
export * from "./PengajuanDasar.vue?vue&type=script&lang=js&"
import style0 from "./PengajuanDasar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports